<div class="inline-spinner-container">
    <div class="loader"> 
        <span></span>
        <span></span>
        <span></span> 
    </div> 
</div>